import create, { GetState, SetState, UseStore } from 'zustand';
import { devtools } from 'zustand/middleware';
import { MessageI } from '../interfaces/interfaces';
import { removeObjFromList } from './actions/shareActionFuncs';
import { AppStatesI } from './interfaces/storeStatesInterface';
import { createGoalStates } from './states/createGoalStates';
import { createTaskStates } from './states/createTaskStates';
import firebase from '../firebase/initFirebase';
import { loadUserAuth, logoutAuth, signInAuth } from './actions/authActions';

export var useStore: UseStore<AppStatesI>;

var _store = (setState: SetState<AppStatesI>, get: GetState<AppStatesI>): AppStatesI => ({
    ...createGoalStates(setState, get),
    ...createTaskStates(setState, get),

    redirect: null,
    isLoading: false,
    messages: [],
    user: null,

    loadUser: async () => loadUserAuth(setState, get),
    loginWith: async (_provider: firebase.auth.AuthProvider) => signInAuth(_provider, setState, get),
    logout: async () => logoutAuth(setState, get),

    setRedirect: (_route: string) =>
        setState(({ redirect: _route })),

    resetRedirect: () =>
        setState(({ redirect: null })),

    setLoading: (_loading: boolean) =>
        setState(({ isLoading: _loading })),

    addMessage: (_message: MessageI) =>
        setState(_preState => ({ messages: [{ ..._message, _id: Math.random().toString(), }, ..._preState.messages] })),

    removeMessage: (_message: MessageI) =>
        setState(_preState => ({ messages: removeObjFromList(_preState.messages, _message, '_id') })),

    // remove all state messages 
    clearStateMessages: (_stateName: string) =>
        setState(_preState => {
            var messages = _preState.messages.filter(_m => _m?.stateName !== _stateName);
            return { messages };
        })
});


if (process.env.NODE_ENV === 'development') {
    useStore = create(devtools(_store));
} else {
    useStore = create(_store);
}